import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-background-queue',
  templateUrl: './background-queue.component.html',
  styleUrl: './background-queue.component.css'
})
export class BackgroundQueueComponent implements OnInit {
  jobs: any[] = [];
  isLoading = false;
  statuses = ['Sent', 'Pending', 'Passed', 'Failed', 'Archived', 'Exception'];
  editOpen = false;
  selectedJob: any = null;
  providers: any[] = [];

  constructor(private data: DataserviceService) {}

  ngOnInit() {
    this.loadQueue();
    this.loadProviders();
  }

  loadQueue() {
    this.isLoading = true;
    this.data.getData('backgrounds/queue').subscribe(
      (res: any) => {
        this.jobs = Array.isArray(res?.data) ? res.data : [];
        this.isLoading = false;
      },
      () => {
        this.jobs = [];
        this.isLoading = false;
      }
    );
  }

  loadProviders() {
    this.data.getData('providers').subscribe(
      (res: any) => {
        const list = Array.isArray(res?.data) ? res.data : res;
        this.providers = Array.isArray(list) ? list : [];
      },
      () => {
        this.providers = [];
      }
    );
  }

  showEdit(job: any) {
    this.selectedJob = { ...job };
    this.editOpen = true;
  }

  closeEdit() {
    this.editOpen = false;
    this.selectedJob = null;
  }

  saveEdit() {
    if (!this.selectedJob?.id) return;
    this.selectedJob._saving = true;

    this.data.postData({
      id: this.selectedJob.id,
      status: this.selectedJob.status,
      background_id: this.selectedJob.background_id,
      provider_id: this.selectedJob.provider_id
    }, 'backgrounds/updateList').subscribe(
      (res: any) => {
        this.selectedJob._saving = false;
        if (res?.result === 'success') {
          this.closeEdit();
          this.loadQueue();
        } else {
          alert('Failed to update background.');
        }
      },
      () => {
        this.selectedJob._saving = false;
        alert('Failed to update background.');
      }
    );
  }

  getProviderName(job: any) {
    if (!job) return '—';
    const providerId = job.provider_id;
    const match = this.providers.find((p: any) => String(p?.id) === String(providerId));
    return match?.name || job?.provider_name || '—';
  }
}
